<template>
  <div class="paragraph-logo">
    <ZtLink :to="link?.uri?.path" class="block">
      <img
        v-bind="size"
        :src="imageUrl"
        :alt="alt"
        class="is-inverted-darkmode block max-h-[40px] w-auto tablet:max-h-[50px] dark:invert"
      />
    </ZtLink>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphLogoFragment } from '#graphql-operations'

const props = defineProps<ParagraphLogoFragment>()

defineBlokkli({
  bundle: 'logo',
  globalOptions: ['bkHiddenGlobally'],
})

const imageUrl = computed<string | undefined>(() => {
  return props.logo?.url?.path
})

const size = computed(() => {
  if (props.logo && 'image' in props.logo && props.logo.image) {
    const width = props.logo.image.width
    const height = props.logo.image.height
    if (width && height) {
      return {
        width,
        height,
      }
    }
  }

  return {}
})

const alt = computed(() => {
  if (props.logo && 'image' in props.logo && props.logo.image) {
    return props.logo.image.alt
  }
  return ''
})
</script>

<style>
.paragraph-logo {
  img {
    max-width: 100px;
    max-height: auto;
  }
}
</style>
